module.exports = "<app-header *ngIf=\"!externalApplication\"></app-header>\n<router-outlet></router-outlet>"